/*

VueJs Gegenstück zur WishlistButton.html aus Fluid

Im Gegensatz zum Fluid ist diese Komponente selbst-registrierend in den shopUtilities

*/
<template>
    <button ref="button" class="button button--ghost button--icon icon--before wish-list" :class="{'icon--wishlist-filled': inWishlist, 'icon--wishlist-empty': !inWishlist}" :data-pid="entity.order_pid"></button>
</template>

<script>
import {shopUtilities, WISHLIST} from "@global/shop-utilities/shop-utilities";

export default {
    name: "wishlist-button",
    props: {
        entity: Object
    },
    data: function() {
        return {
            inWishlist: shopUtilities.isAdded(WISHLIST, this.entity.order_pid)
        };
    },
    mounted() {
        this.listenersCallback = shopUtilities.registerListeners(this.$refs.button, WISHLIST);
    },
    beforeDestroy() {
        if (this.listenersCallback) {
            this.listenersCallback();
        }
    },
}
</script>
